import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export interface InlineInputBoxAbortedMessageCommandProperties extends CommandProperties {
	/** Editor-owned token of the aborted turn, echoed from the send command when one was provided. */
	inlineRovoEditAttemptId?: string;
}

/**
 * A command sent by the rovo client to tell the inline input box that the in-flight turn was aborted
 * (e.g. the user pressed Stop in Rovo Chat), so it can stop waiting for a response.
 *
 * @summary {@link CommandProperties.senderId} is informing {@link CommandProperties.receiverId} that the ongoing message was aborted.
 */
export const InlineInputBoxAbortedMessageCommand: CommandConstructor<
	InlineInputBoxAbortedMessageCommandProperties,
	void
> = createCommand<InlineInputBoxAbortedMessageCommandProperties, void>(
	'inline-input-box-aborted-message-command',
);
